import { Component, Input } from '@angular/core';
import { NetworkService, ZoneSummary } from '../../network.Service';
import { plainToClass } from 'class-transformer';
import { ViewChild } from '@angular/core';
import { ProgressIndicatorComponent } from '../../templates/progress-indicator/progress-indicator.component';
import { FileUploadComponent } from '../../file-upload/file-upload.component';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrl: './service-list.component.css'
})
export class ServiceListComponent {
  displayedColumns = ['Name', 'IpAddress', 'Port', 'Type', 'Status'];
  processingServices: boolean = false;

  @ViewChild('pi', { static: true }) pi: ProgressIndicatorComponent | undefined;
  @ViewChild('zoneUpload') zoneUpload: FileUploadComponent | undefined;

  constructor(private networkService: NetworkService) {
  }

  edit(service: ZoneSummary) {

  }

  zoneType(type: number): string {
    switch (type) {
      case 0: return "Shotgun";
      case 1: return "SMS Gateway";
      case 2: return "Message Manager";
      case 7: return "Email Gateway";
      case 6: return "WhatsApp Gateway";
      case 8: return "S3 Email to SMS Gateway";
      default: return "Unknown";
    }
  }

  zoneStatus(status: number): string {
    switch (status) {
      case 0: return "Starting";
      case 1: return "Running";
      case 2: return "Stopped";
      default: return "Unknown";
    }
  }

  @Input()
  get services(): ZoneSummary[] {
    return this._services;
  }
  set services(value: ZoneSummary[]) {
    this._services = value;
  }
  private _services: ZoneSummary[] = [];

  download() {
    this.networkService.getZoneFile().subscribe({
      next: (result: any) => {
        const blob = new Blob([result.File], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'zonefile.xml';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    })
  }

  upload($event: any) {
    this.uploadZoneFile($event.name);
  }

  uploadZoneFile(zonefile: string) {
    this.networkService.setZoneFile(zonefile).subscribe({
      next: (result) => {
        this.getSummary();
        this.zoneUpload.progress = 0;
        this.zoneUpload.message = "";
      },
      error: (error) => {
        var a = error;
        this.zoneUpload.progress = 0;
        this.zoneUpload.message = "Problem. Investigate";
      }
    });
  }

  getSummary() {
    this.processingServices = true;
    this.networkService.getSummary().subscribe({
      next: (result) => {
        this.services = [];
        for (let i = 0; i < result.length; i++) {
          this.services.push(plainToClass(ZoneSummary, result[i]));
        }

        this.zoneUpload.uploading = false;
        this.pi?.updateProcessing(false);
        this.processingServices = false;
      },
      error: (error) => {
        this.pi?.updateProcessing(false);
        this.zoneUpload.uploading = false;
        this.processingServices = false;
      }
    });
  }
}
